/**
 * Combsol Theme — Dark Only.
 * Light-Mode wurde entfernt. Die App ist permanent im Dark-Mode.
 */
export type Theme = "dark";
export const THEME_KEY = "combsol-theme";

export function getStoredTheme(): Theme {
  return "dark";
}

export function getInitialTheme(): Theme {
  return "dark";
}

export function applyTheme(_theme?: Theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.classList.add("dark");
  root.dataset.theme = "dark";
  root.style.colorScheme = "dark";
}

export function setTheme(_theme: Theme) {
  // Dark-only: kein Wechsel möglich
  applyTheme();
}

export function toggleTheme(): Theme {
  return "dark";
}
